import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PrintService } from 'src/app/services/print.service';
import { BOOK_STORE_TABS } from 'src/app/dummy/tab';
import { RegisterTesting } from 'src/app/stores/enrollment/registerTesting.store';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { BookstoreStore } from 'src/app/stores/bookstore/bookstore.store';
import { ConfigStore } from 'src/app/stores/config.store';
import { AddRegisterTestResultComponent } from './add-register-test-result/add-register-test-result.component';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-register-test',
  templateUrl: './register-test.component.html',
  styleUrls: ['./register-test.component.scss']
})
export class RegisterTestComponent implements OnInit {
  @ViewChild('PRINT_TABLE', {static:false}) PRINT_TABLE: ElementRef;
  tabs: any[] = BOOK_STORE_TABS.REGISTER_TESTING;
  PROGRAM_KEY: any;
  PROGRAM_LIST: any[] = [];
  TERM:any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public store: RegisterTesting,
    public ps: PrintService,
    public auth: AuthStore,
    private book: BookstoreStore,
    private config:ConfigStore,
    private dialog:MatDialog,
  ) { }

  async ngOnInit() {
    this.PROGRAM_LIST = await this.book.fetchListArray('general_placement_test', "page_key");
    this.tabs =this.tabs.concat(this.PROGRAM_LIST.map(m => ({ path: `/enrollment/register-test/${m.key}`, label: m.name, key: m.key })))
    this.TERM = await this.config.fetchTerm();
    if(!this.TERM){
      this.router.navigate([`404`])
      return;
    }
    this.route.params.subscribe(async (param) => {
      this.PROGRAM_KEY = param['id'];
      const { selectedCompanyKey } = this.auth;
      this.store.fetchData(selectedCompanyKey,this.TERM.key,this.PROGRAM_KEY)
    })
  }

  create() {
    this.router.navigate([`/enrollment/register-test/form/draft`])
  }

  edit(item: any) {
    this.router.navigate([`/enrollment/register-test/form/${item.key}`])
  }

  onSetResult(item: any) {
    let dialogRef = this.dialog.open(AddRegisterTestResultComponent, {
      data: {
        ITEM: item,
      },
      panelClass: 'item-list-panel',
      width: '',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => {});
  }

}
